import { UniversalLibraryContextValue } from './types';

/**
 * Default context value when UniversalLibraryProvider is not available
 * Provides safe fallbacks for all operations
 */
export const createDefaultContext = (): UniversalLibraryContextValue => ({
  selectedContentType: 'all',
  searchQuery: '',
  selectedCategory: null,
  contentTypes: {},
  
  // Safe no-op functions
  registerContentType: () => {
    console.warn('[UniversalLibrary] registerContentType called outside provider context');
  },
  setSelectedContentType: () => {
    console.warn('[UniversalLibrary] setSelectedContentType called outside provider context');
  },
  setSearchQuery: () => {
    console.warn('[UniversalLibrary] setSearchQuery called outside provider context');
  },
  setSelectedCategory: () => {
    console.warn('[UniversalLibrary] setSelectedCategory called outside provider context');
  },
  triggerRefetch: () => {
    console.warn('[UniversalLibrary] triggerRefetch called outside provider context');
  },
  onRefetchNeeded: () => {
    console.warn('[UniversalLibrary] onRefetchNeeded called outside provider context');
    return () => {}; // Return cleanup function
  },
}); 